<template>
    <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        <div class="kt-portlet kt-portlet--mobile">
            <div class="kt-portlet__head kt-portlet__head--lg no-border-radius">
                <div class="kt-portlet__head-label">
                    <Dropdown v-model="selectedOrg" :options="organizations"
                              optionLabel="display_name" :placeholder="$t('AppDevices.Organização')"
                              class="auto-center" :dataKey="'id'"
                              :filter="true"
                              style="width: 250px"
                              @input="saveChosenOptionsToLocalStorage">
                        <template #option="slotProps" style="width: 500px">
                            <div v-if="loadingOrgs"> {{ $t('AppDevices.Carregando, aguarde') }}</div>
                            <div style="padding-right: 20px" v-else-if="slotProps.option.name === 'ND'">
                                -
                            </div>
                            <div style="padding-right: 20px" v-else>
                                {{ slotProps.option.display_name }}
                            </div>
                        </template>
                    </Dropdown>
                </div>
            </div>
            <div class="kt-portlet__body no-padding">
                <div class="card data-table-width">
                    <DataTable :value="gridData" :paginator="true" :rows="50" :rowHover="true" :loading="loading" stripedRows  :showGridlines="true"
                                :sortOrder="-1" sortField="last_update_date"
                                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                :rowsPerPageOptions="[10,25,50]"
                                :currentPageReportTemplate="$t('AppDevices.currentPageReportTemplate')"
                                :selection.sync="selected_beacons" selectionMode="single" dataKey="mac_address"
                                class="p-datatable-customers"
                                :filters.sync="filters" filterDisplay="row" responsiveLayout="scroll">
                        <template #header>
                            <div style="text-align: right">
                                <Button icon="pi pi-external-link" :label="$t('AppDevices.Exportar')" @click="exportCsv" style="font-size: 13px;" />
                            </div>
                        </template>
                        <template #empty>
                            {{ $t('AppDevices.Sem dados para exibir') }}
                        </template>
                        <template #loading>
                            {{ $t('AppDevices.Carregando dipositivos, por favor aguarde') }}


                        </template>
                        <Column field="mac_address" :header="$t('AppDevices.Serial')" headerClass="headerClass" :styles="{'min-width':'10rem'}" :showFilterMenu="false" :showClearButton="false"
                                :sortable="true" filterMatchMode="custom" bodyClass="bodyClass" :filterFunction="filterValue">
                            <template #body="slotProps">
                                {{slotProps.data.mac_address}}
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="linked_entity_name" :header="$t('AppBeacons.Identificação')" headerClass="headerClass" :styles="{'min-width':'12rem'}" bodyClass="bodyClass"
                                :sortable="true" filterMatchMode="contains" :showFilterMenu="false">
                            <template #body="slotProps">
                                {{slotProps.data.linked_entity_name}}
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="type" :header="$t('AppBeacons.Tipo')" headerClass="headerClass" :styles="{'min-width':'12rem'}" bodyClass="bodyClass"
                                :sortable="true" filterMatchMode="contains" :showFilterMenu="false">
                            <template #body="slotProps">
                                {{slotProps.data.type ? $t('AppBeacons.'+ slotProps.data.type) : null}}
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                    </DataTable>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import {router} from '../../../router';
import axios from '../../../axios/axios-auth';
import {mapGetters} from 'vuex';
import maskCpfCnpj from "../../../mixins/StringsMaskMixin";
import dateHourFormat from "../../../mixins/DateMixin";
import maskMacAddress from "../../../mixins/StringsMaskMixin";
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import MultiSelect from 'primevue/multiselect';
import Calendar from 'primevue/calendar';
import Dropdown from 'primevue/dropdown';
import ProgressBar from 'primevue/progressbar';
import Button from 'primevue/button'
import BeaconsService from "../../../services/BeaconsService";
import {STATUS} from "../../../constants/status";
import AppButton from "../../common/AppButton";
import filterValue from "../../../mixins/FilterFunctionsDataTables";
import formatData from "../../../mixins/SizesMixin"
import OrganizationsService from "@/services/OrganizationsService";
import orderCustomFieldByNaturalOrder from "@/mixins/ArrayMixin";
import exportJsonToCsv from '@/mixins/JsonToCsvMixin';
import {FilterMatchMode} from 'primevue/api';
import {FilterService} from 'primevue/api';
const DATE_FILTER = 'DATE FILTER';

export default {
    mixins: [maskCpfCnpj, maskMacAddress, status, dateHourFormat, filterValue, formatData, orderCustomFieldByNaturalOrder, exportJsonToCsv],
    mounted() {
        this.beaconsService = new BeaconsService();
        FilterService.register(DATE_FILTER, (value, filter) => {
            if (filter === undefined || filter === null || filter.trim() === '') {
                return true;
            }

            if (value === undefined || value === null) {
                return false;
            }

            return this.dateHourFormat(value).includes(filter);
        });
        this.organizationsService = new OrganizationsService();
        this.getOrganizations();
    },
    data() {
        return {
            beaconsService: null,
            selected_beacons: [],
            loading: false,
            filters: {
                'mac_address': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'linked_entity_name': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'type': {value: null, matchMode: FilterMatchMode.CONTAINS},
            },
            gridData: [],
            organizations: [],
            organizationsService: null,
            loadingOrgs: false,
            selectedOrg: null,
            storedChosenOptions: {}
        }
    },
    components: {
        DataTable,
        Column,
        InputText,
        MultiSelect,
        Calendar,
        Dropdown,
        ProgressBar,
        Button,
        AppButton
    },
    methods: {
        exportCsv(){
            let csvData = [];

            let tempData = JSON.parse(JSON.stringify(this.gridData));

            tempData.forEach(data => {
                data.last_contact = this.dateHourFormat(data.last_contact);
                csvData.push(data);
            });

            const CSV_FIELDS = ['last_contact', 'city', 'state', 'mac_address', 'model', 'iccid', 'fleet', 'vin', 'vehicle_manufacturer', 'vehicle_model'];
            const CSV_LABELS = [this.$t('AppDevices.Horário'), this.$t('AppDevices.Município'), this.$t('AppDevices.Estado'), this.$t('AppDevices.Serial'), this.$t('AppDevices.Versão'), this.$t('AppDevices.Assinatura'), this.$t('AppDevices.Frota'), this.$t('AppDevices.Chassi'), this.$t('AppDevices.Marca'), this.$t('AppDevices.Modelo')];

            this.exportJsonToCsv(CSV_FIELDS, CSV_LABELS, csvData, "devices");
        },
        formatICCID(val) {
            // retira os quatro primeiros digitos do iccid se estiveram presentes
            // 2 primeiros codigo da industria sempre 89
            // 2 seguintes codigo do pais, 55 no caso do brasil
            if (!val) {
                return "";
            }

            if (val.length <= 16) {
                return val;
            }
            return val.substring(4);
        },
        getOrganizations() {
            let vm = this;
            this.loadingOrgs = true;
            this.organizationsService.getAllV3('BEACONS').then((results) => {
                this.populateOrgsList(results);
                this.loadFilteredOptions();
            })
                .catch((error) => {
                    vm.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppDevices.Operação falhou'),
                        detail: this.$t('AppDevices.Não foi possível buscar organizações'),
                        life: 5000
                    });
                    console.log(error)
                }).finally(() => {
                this.loadingOrgs = false;
            })
        },
        populateOrgsList(orgs) {
            orgs.forEach(data => {
                data.mac_address = this.maskMacAddress(data.mac_address);
                data.iccid = this.formatICCID(data.iccid);
            });
            this.organizations = this.orderCustomFieldByNaturalOrder(orgs, "name");
        },
        getBeacons(selectedOrg) {
            let vm = this;
            this.loading = true
            this.beaconsService.getAllBeaconsByOrgId(selectedOrg.id).then((response) => {
                vm.gridData = response

                this.beaconsService.getBeaconsLinksByOrgId(selectedOrg.id).then((response) => {
                    response.forEach(data => {
                        if (!(data.end_date)) {
                            let dict = vm.gridData.find(item => item.mac_address === data.mac_address);
                            Object.assign(dict, {linked_entity_name: data.linked_entity_name, type: data.type})
                        }
                    });
                }).then(() => {
                    vm.$forceUpdate();
                })
            }).catch(function (error) {
                if (!error.response || error.response.status !== 403) {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppDevices.Não foi possivel completar a operação'),
                        life: 5000
                    });
                    return;
                }
                vm.$toast.add({
                    severity: 'error',
                    summary: this.$t('AppDevices.Você não tem acesso a esta funcionalidade'),
                    life: 5000
                });
            }).finally(() => {
                vm.loading = false;
            })
        },
        loadFilteredOptions() {
            this.storedChosenOptions = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE_FILTER_BAR_OPTIONS));

            if (!this.storedChosenOptions || !this.storedChosenOptions.clients || this.storedChosenOptions.clients.length === 0) {
                this.storedChosenOptions = {};
                return;
            }

            this.selectedOrg = this.storedChosenOptions['clients'].filter(a => this.organizations.some(b => a.id === b.id))[0];
        },
        saveChosenOptionsToLocalStorage() {
            this.storedChosenOptions['clients'] = [this.selectedOrg];
            this.storedChosenOptions['vehicles'] = [];
            localStorage.setItem(process.env.VUE_APP_LOCAL_STORAGE_FILTER_BAR_OPTIONS, JSON.stringify(this.storedChosenOptions));
        },
    },
    watch: {
        selectedOrg: function (val) {
            if (!val) {
                return;
            }
            this.getBeacons(val)
        }
    },
    computed: {
        ...mapGetters([
            'getCurrentOrganization',
            'isAuthenticated',
        ])
    },
}
</script>


<style lang="scss">
@import "./src/assets/styles/primevue";


@media (max-width: 1024px){
    .data-table-width{
        width: 100vw;
    }
}

@media (min-width: 1025px){
    .data-table-width{
        max-width: calc(100vw - 140px);
    }
}
</style>
